<template>
    <div class="buy-now-login">
        <login-form
                :loading="loading"
                :login-error="loginError"
                v-on:submit="submit"
        />
    </div>
</template>

<script>
    import LoginForm from '../login-form-home';

    export default {
        components: {
            LoginForm
        },
        props: {
            order: Object,
            currentUrl: String
        },
        data: function() {
            return  {
                loading: false,
                loginError: null
            }
        },
        methods: {
            submit(email, password) {
                this.loading = true;
                this.loginError = null;

                this.$api.patch('v1/accounts/login', {email: email, password: password })
                    .then(res => this.onLogin())
                    .catch(err => {
                        this.loading = false;
                        this.loginError = 'Invalid Email or password.';
                    })
            },
            onLogin() {
                localStorage.setItem('BuyNowIncompleteOrder', JSON.stringify(this.order));
                window.location.replace(this.currentUrl);
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .buy-now-login {
        padding: 0 2rem;
    }

</style>
